export default {
    UltimaVisualizacao: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "ultima-visualizacao"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/UltimaVisualizacao.js
// module id = GAEF
// module chunks = 13